import React, { useRef } from 'react';
import { Paper, IconButton, Tooltip, Divider, Box } from '@mui/material';
import {
  AddCircleOutline as AddIcon,
  RemoveCircleOutline as RemoveIcon,
  Image as ImageIcon,
} from '@mui/icons-material';

/**
 * Floating context menu for table manipulation.
 * Shows buttons to add/delete rows and columns, and insert images.
 */
export default function TableContextMenu({ position, onAddRow, onDeleteRow, onAddColumn, onDeleteColumn, onInsertImage, onClose }) {
  const fileInputRef = useRef(null);
  
  if (!position) return null;

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onInsertImage) {
      onInsertImage(file);
    }
    // Reset input so same file can be selected again
    e.target.value = '';
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        p: 1,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
        <Tooltip title="Add row below">
          <IconButton size="small" onClick={onAddRow} color="primary">
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <span style={{ fontSize: '0.875rem', color: '#666' }}>Row</span>
        <Tooltip title="Delete current row">
          <IconButton size="small" onClick={onDeleteRow} color="error">
            <RemoveIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Divider />

      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
        <Tooltip title="Add column right">
          <IconButton size="small" onClick={onAddColumn} color="primary">
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <span style={{ fontSize: '0.875rem', color: '#666' }}>Col</span>
        <Tooltip title="Delete current column">
          <IconButton size="small" onClick={onDeleteColumn} color="error">
            <RemoveIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Divider />

      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', justifyContent: 'center' }}>
        <Tooltip title="Insert image in cell">
          <IconButton size="small" onClick={handleImageClick} color="primary">
            <ImageIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <span style={{ fontSize: '0.875rem', color: '#666' }}>Image</span>
      </Box>

      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </Paper>
  );
}
